/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import Effect from "./Effect";

// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass
export default class SkinSwapEffect extends Effect {

    @property({ visible: true })
    protected to: string = '';

    @property({ visible: true })
    protected from: string = '';

    @property({ visible: true })
    protected prefetch: boolean = false;

    @property({ visible: true })
    protected fetchOnce: boolean = false;

    @property({ visible: true })
    protected reverse: boolean = false;

    @property({ type: [cc.Node], visible: true })
    protected targets: cc.Node[] = [];

    private _targets: sp.Skeleton[] = null;

    protected start(): void
    {
        super.start();

        if (this.prefetch)
        {
            this._fetchTargets();
        }
    }

    protected swap(): void
    {
        this._fetchTargets();

        const to: string = this.reverse ? this.from : this.to;
        for (let target of this._targets)
        {
            // Hacky way of accessing the spine runtime directly since cocos doesn't expose what we need.
            // I'd like to thank JavaScript for not having access modifiers, it truly is the worst.
            // tslint:disable-next-line:no-string-literal
            if (target['_sgNode']['_skeleton']['data']['findSkin'](to))
            {
                target.setSkin(to);
            }
        }
    }

    protected trigger = (): void =>
    {
        this.swap();
        this.complete();
    }

    private _fetchTargets(): void
    {
        if (this._targets && this.fetchOnce) { return; }

        let targets: sp.Skeleton[] = [];
        for (let target of this.targets)
        {
            const top: sp.Skeleton = target.getComponent(sp.Skeleton);
            const children: sp.Skeleton[] = target.getComponentsInChildren(sp.Skeleton);

            if (top) { targets.push(top); }
            if (children) { targets = targets.concat(children); }
        }

        this._targets = targets;
    }
}
